import React, {useState} from 'react';
import {ButtonMUI, DialogMUI, IconButtonMUI} from '../../../shared';
import {useTranslation} from 'react-i18next';
import './ConfirmPopup.scss';
import {ReactComponent as CloseIcon} from '../../../assets/icons/close.svg';
import {ReactComponent as AttentionIcon} from '../../../assets/icons/attention.svg';
import {useDispatch, useSelector} from 'react-redux';
import {hideConfirmPopup} from '../../../redux/actions/app/appActions';

const ConfirmPopup = () => {
  const dispatch = useDispatch();
  const confirmPopup = useSelector(({app}) => app.confirmPopup);
  const [disabled, setDisabled] = useState(false);
  const {t} = useTranslation();

  const handleClose = () => {
    dispatch(hideConfirmPopup());
  };

  const title = confirmPopup.title ? confirmPopup.title : 'Видалення';
  const text = confirmPopup.text ? confirmPopup.text : 'Ви дійсно бажаєте видалити це з сервісу?';

  return (
    <DialogMUI
      open={confirmPopup.visible}
      title={t('ReviewPopup.title')}
      withoutDefaultWrapper={true}
      maxWidth={'xs'}
      onClose={handleClose}
    >
      <div className='confirm-popup'>
        <div className='confirm-popup__exit'>
          <IconButtonMUI color={'inherit'} onClick={handleClose} disabled={disabled}>
            <CloseIcon />
          </IconButtonMUI>
        </div>
        <div className='confirm-popup__inner'>
          <div className='confirm-popup__svg'>
            <AttentionIcon />
          </div>
          <h3 className='confirm-popup__title'>{title}</h3>
          <p className='confirm-popup__text'>{text}</p>
          <div className='confirm-popup__buttons'>
            <ButtonMUI
              variant={'contained'}
              color={'secondary'}
              className={'button-red'}
              loading={disabled}
              onClick={async () => {
                setDisabled(true);
                await confirmPopup.confirmCallback();
                handleClose();
                setTimeout(() => {
                  setDisabled(false);
                }, 300);
              }}
            >
              {t('all.yes')}
            </ButtonMUI>
            <ButtonMUI variant={'outlined'} onClick={handleClose} disabled={disabled}>
              {t('all.no')}
            </ButtonMUI>
          </div>
        </div>
      </div>
    </DialogMUI>
  );
};

export default ConfirmPopup;
